<template>
  <bs-modal
    ref="bsModal"
    :name="`update-proposal-${issueid}`"
    :ok-title="$t('javascript.update_visible')"
    :cancel-title="$t('javascript.cancel')"
    @ok="$emit('ok')"
    @cancel="$emit('cancel')"

    :disableOk="true"
    :disableCancel="true"

    :value="value"
    @input="$emit('input', $event)"
  >
    <form class="form-inline">
      <div class="form-group">
        <div class="row">
          <div class="col-sm-3" style="margin-top:10px;">
            <button type="button" class="btn btn-secondary" @click="handleCancelClick">
              {{ $t('javascript.cancel') }}
            </button>
          </div> 
          <div class="col-sm-4">
            <button type="button" class="btn btn-primary" @click="handleOkClick">
              {{ $t('javascript.update_visible') }}
            </button>
          </div>
          <div class="col-sm-3" style="margin-top:15px;">
            <span v-html="$t('javascript.from_last_position', {lastPosition})"></span>
          </div>
          <div class="col-sm-2" style="margin-top:10px;">
            <select
              :value="proposal"
              @input="$emit('update:proposal', getProposal($event))"
              class="form-control form-inline"
            >
              <option v-for="point in gridPoints">
                {{ point }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <p></p>
      <div class="alert alert-danger size-12" role="alert">
        <i class="fa fa-exclamation-triangle"></i>
          {{ $t('javascript.other_party_shown_new_value') }}
      </div>
    </form>
  </bs-modal>
</template>

<script>
  import BsModal from './bs_modal'

  export default {
    name: "update-proposal",
    props: [
      'proposal',     // Number
      'value',        // Boolean
      'gridPoints',   // Array
      'lastPosition', // Number
      'issueid' // Number
    ],
    components: {BsModal},
    methods: {
      getProposal(event) {
        return parseFloat(event.target.value)
      },
      handleOkClick() {
        this.$emit('ok')
        this.$refs.bsModal.modalHide()
      },
      handleCancelClick() {
        this.$emit('cancel')
        this.$refs.bsModal.modalHide()
      }
    }
  }
</script>
